module.exports = __webpack_public_path__ + "static/media/danielle_english_us.c6e45f62.mp3";